export const TIRE_LIFE_TOOLTIPS = {
  milesPerDollar:
    'Miles per dollar is calculated by dividing the median tire mileage by the retail price of the tire.',
  tireLife:
    'We calculate tire life estimates by dividing its median mileage by the number of miles you drive per year.'
};
